import i18n from 'i18next';

/**
 * The knowledge base skeleton's own namespace (SL-1909, part 2). The skeleton is
 * in the initial bundle (RouteSkeleton, the agent layouts, the router), so it
 * must not import the `knowledge` namespace — the whole feature's copy, which
 * every user would download before any screen. It carries only what the
 * skeleton says: its label. `__tests__/KnowledgeSkeleton.test.tsx` keeps the
 * three languages in step.
 */
export const NS = 'knowledge-skeleton';

export const en = { loading: 'Loading the knowledge base' };
export const es: typeof en = { loading: 'Cargando la base de conocimiento' };
export const pt: typeof en = { loading: 'Carregando a base de conhecimento' };

// Guarded so importing this module is safe where the i18next singleton isn't
// initialized (the jest runner); in the app it is, before the first render.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}
